import React from 'react'

export default function CountryFlag(props) {
  const {code, width = 25} = props

  return (
    <img
      src={`https://files.getjusto.com/app/images/flags/${code.toLowerCase()}.svg`}
      width={width}
    />
  )
}
